/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum VendorEnum {
    GENERIC = 0,
    F5 = 1,
    KEMP = 2,
    A10 = 3,
    CITRIX = 4,
    LBENTERPRISE = 5,
    LBENDURANCE = 6,
    EDGENEXUS = 7
}
